// extracted by mini-css-extract-plugin
export default {"mainWrapper":"NetworkStatus_mainWrapper__n5XNv","mainContainer":"NetworkStatus_mainContainer__6Lsu9","backgroundImage":"NetworkStatus_backgroundImage__W5OuG"};